export const PAYSTACK_BASE_URL = 'https://api.paystack.co'
export const FLUTTERWAVE_BASE_URL = 'https://api.flutterwave.com/v3/'

export const PAYSTACK_SECRET_KEY = 'sk_test_8c231ece81620c5dfe92377a418f6165acec884d'
export const PAYSTACK_PUBLIC_KEY = 'pk_test_1bd3d130cbb6f84a90e8cdb0e13a82a659ebbedc'
export const FLUTTERWAVE_PUBLIC_KEY = 'FLWPUBK_TEST-b7eb58ee9768abf02faebf8420d803b5-X'
export const FLUTTERWAVE_SECRET_KEY = 'FLWSECK_TEST-6ab670331373e9e37e5452d8a3442d94-X'